import clsx from 'clsx'
import type { HTMLAttributes, ReactNode } from 'react'
import styles from './CommentHeader.module.css'

export interface CommentHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
	title?: ReactNode
	desc?: ReactNode
}

export default function CommentHeader({ title, desc, className, ...props }: CommentHeaderProps) {
	return (
		<header className={clsx(styles.header, className)} {...props}>
			<div className={styles.title}>{title}</div>
			<div className={styles.desc}>{desc}</div>
		</header>
	)
}
